import { ClientGeoArea } from '@DigitaleDoerfer/digitale-doerfer-api';

export type GeoAreaDropdownItem = {
  level?: number;
  path?: string;
  isSelected?: boolean;
} & ClientGeoArea;

/**
 * Returns a new array with all sub-array (childGeoAreas) elements concatenated into it recursively up to 1 depth.
 * @param geoAreas
 */
export const prepareDropdownData = (
  geoAreas?: GeoAreaDropdownItem[]
): GeoAreaDropdownItem[] => {
  if (!geoAreas) return [];
  const flattenedTree: GeoAreaDropdownItem[] = [];
  const recurseOverChildAreas = (
    parentArea: GeoAreaDropdownItem,
    level = 0,
    path = ''
  ): void => {
    const newLevel = level + 1;
    const pathParentNoLeaf = !parentArea.leaf ? ` › ${parentArea.name}` : '';
    const updatedParentArea = {
      ...parentArea,
      level: newLevel,
      path: newLevel > 1 ? `${path} ${pathParentNoLeaf}` : parentArea.name
    };
    flattenedTree.push(updatedParentArea);
    if (
      updatedParentArea.childGeoAreas &&
      updatedParentArea.childGeoAreas.length
    ) {
      updatedParentArea.childGeoAreas.forEach((childArea) => {
        recurseOverChildAreas(
          childArea,
          updatedParentArea?.level,
          updatedParentArea?.path
        );
      });
    }
  };
  geoAreas.forEach((area) => recurseOverChildAreas(area));
  return flattenedTree;
};
